export const LayerSection = ({ layer, children, delay = 0 }) => (
  <section className="relative pl-14 sm:pl-20 fade-up" style={{ animationDelay: `${delay}ms` }} data-testid={`layer-${layer.key}`}>
    <span className={`absolute left-0 top-0 h-10 w-10 sm:h-12 sm:w-12 rounded-full grid place-items-center font-display text-lg sm:text-xl bg-${layer.key}-soft text-${layer.key} border border-current`}
      aria-hidden="true">{layer.letter}</span>
    <div className="flex items-baseline gap-3 min-h-[40px] sm:min-h-[48px] pt-1.5">
      <h3 className={`font-display text-xl sm:text-2xl text-${layer.key}`}>{layer.letter} · {layer.name}</h3>
      <span className="eyebrow">{layer.sub}</span>
    </div>
    <div className="mt-4 space-y-5">{children}</div>
  </section>
);

export const Boxes = ({ layerKey, items }) => (
  <div className="grid md:grid-cols-3 gap-3">
    {items.map(([title, list]) => (
      <div key={title} className={`rounded-xl p-4 bg-${layerKey}-soft`} data-testid={`box-${layerKey}-${title.toLowerCase()}`}>
        <div className={`eyebrow !text-${layerKey} mb-2`}>{title}</div>
        <ul className="space-y-2">
          {(list || []).map((x, i) => <li key={i} className="text-sm text-ink leading-relaxed">{x}</li>)}
        </ul>
      </div>
    ))}
  </div>
);
